import React, { useLayoutEffect, useState } from "react";
import MainTemplate from "@/components/Templates/MainTemplate";
import { TermsPageContent } from "./AppTemplate";
import { getURLParams } from "@/utils";
import useDisableIntercom from "@/hooks/useDisableIntercom";

function TermDesktopTemplate() {
  const [isDesktopWebView, setIsDesktopWebView] = useState(false);

  useDisableIntercom({});
  useLayoutEffect(() => {
    const params = getURLParams();
    const source = params?.get("source") || "";

    if (source?.toLowerCase() !== "app") {
      setIsDesktopWebView(true);
    }
  }, []);

  if (isDesktopWebView) {
    return (
      <MainTemplate>
        <TermsPageContent showHeader webmode />
      </MainTemplate>
    );
  } else {
    return <TermsPageContent />;
  }
}

export default TermDesktopTemplate;
